const ph = {
  "home": "Home", // 单词翻译
  "profile": "Profile", // 单词翻译
  "product": "Produkto", // 单词翻译
  "select": "Piliin", // 单词翻译
  "selected": "Napili", // 单词翻译
  "address": "Address", // 单词翻译
  "description": "Paglalarawan", // 单词翻译
  "lease": "Upahan", // 单词翻译
  "leaseTips": "Nasa Daan Na! Ang iyong package ay inihahatid na. 【DR_Dennis Gonzales : 9458674829】Para sa COD，mangyaring maghanda ng eksaktong halaga. Kailangan ng larawan bilang patunay ng paghahatid. Salamat!",
  "buyNow": "Bilhin Ngayon", // 单词翻译
  "unavailable": "Hindi Available", // 单词翻译
  "priceUnit": "Rp", // 金额单位
  "confirm": "Kumpirmahin", // 单词翻译
  "cancel": "Kanselahin", // 单词翻译
  "back": "Bumalik",
  "close": "Isara",
  "appName": "Genggo",
  "loading": "Naglo-load...", // 加载中提示 单词翻译
  "logout": "Mag-logout", // 单词翻译
  "loginExpired": "Nabigo ang pag-login. Mangyaring subukang mag-login muli.",// 登录过期提示
  "addAddress": "Magdagdag ng Address", // 单词翻译
  "addressList": "Listahan ng Address", // 单词翻译
  "default": "Default", // 单词翻译
  "language": "Wika", // 单词翻译
  "FAQ": "FAQ", // 单词翻译
  "customerService": "Serbisyo sa Customer",
  "customerServicePop": {
    "whatsapp": "WhatsApp",
    "copy": "Kopyahin",
    "copySuccess": "Nakopya"
  },
  "customerSupportFloating": {
    "whatsapp": "WhatsApp",
    "expand": "Buksan ang suporta sa WhatsApp",
    "collapse": "Isara ang suporta sa WhatsApp",
    "open": "Makipag-chat sa suporta sa WhatsApp",
    "online": "ONLINE NGAYON",
    "title": "Suporta sa WhatsApp",
    "subtitle": "I-tap para makipag-chat sa Genggo"
  },
  "edit": "I-edit", // 单词翻译
  "delete": "I-delete", // 单词翻译
  "addSuccess": "Matagumpay na Naidagdag", // 单词翻译
  "saveSuccess": "Matagumpay na Nai-save", // 单词翻译
  "deleteSuccess": "Matagumpay na Nai-delete", // 单词翻译
  "noMore": "Wala Na", // 没有更多数据提示
  "languageSettings": "Mga Setting ng Wika", // 单词翻译
  "systemError": "System error. Pakisubukan muli mamaya.", // 系统错误提示
  "withholdingAuth": {
    "title": "Paganahin ang awtomatikong pagbabayad",
    "subtitle": "Awtorisahin ang DANA na magbayad ng mga susunod na singil sa pag-renta.",
    "description": "Awtomatiko naming sisimulan ang pagbabayad sa bawat takdang petsa upang matulungan kang maiwasan ang mga hindi nabayarang bayarin at huli na singil.",
    "agreePrefix": "Nabasa ko at sumasang-ayon ako sa ",
    "agreement": "Auto-debit Authorization Agreement",
    "notNow": "Mamaya na",
    "authorize": "Awtorisahin"
  },
  "retry": "Subukan muli",
  "indexPage": {
    "title": "Home", // 首页标题
    "productTitle": "Produkto", // 首页产品列表标题
    "greeting": "Hello",
    "subtitle": "Mas madali na ngayong makuha ang pinapangarap mong iPhone.",
    "bannerAriaLabel": "Mga tampok na promosyon",
    "bannerLoadFailed": "Hindi ma-load ang mga banner",
    "bannerEmptyTitle": "Walang available na banner",
    "bannerEmptyDescription": "Dito lalabas ang mga promosyon at update sa produkto.",
    "shortcutsAriaLabel": "Mga shortcut sa home",
    "myProfile": "Aking Profile",
    "products": "Mga Produkto",
    "stores": "Mga Tindahan",
    "faq": "FAQ",
    "featuredProducts": "Mga Tampok na Produkto",
    "seeAll": "Tingnan lahat"
  },
  "bottomNav": {
    "ariaLabel": "Pangunahing nabigasyon",
    "home": "Home",
    "products": "Mga Produkto",
    "account": "Account"
  },
  "productCommon": {
    "firstRentalAmount": "Unang halaga ng upa",
    "pricePending": "Hinihintay ang presyo",
    "applyNow": "Mag-apply Ngayon",
    "rented": "rented",
    "noCreditCard": "Hindi kailangan ng credit card",
    "onlineProcess": "Online na proseso",
    "benefitSummary": "Benefit Summary",
    "lightInstallments": "Light installments",
    "deliveryOnlineProcess": "100% Online Process",
    "freeShippingJabodetabek": "Free Shipping for Online Payment"
  },
  "productState": {
    "loading": "Naglo-load…",
    "loadFailed": "Hindi ma-load ang data",
    "emptyTitle": "Walang available na produkto",
    "emptyDescription": "Dito lalabas ang mga available na rental device kapag handa na ang mga ito.",
    "searchEmptyTitle": "Walang nahanap na katugmang produkto",
    "searchEmptyDescription": "Subukan ang ibang keyword o i-clear ang paghahanap."
  },
  "productsPage": {
    "title": "Mga Produkto",
    "searchPlaceholder": "Maghanap ng iPhone o modelo",
    "clearSearch": "I-clear ang paghahanap",
    "closeSearch": "Isara ang paghahanap",
    "recentSearches": "Mga kamakailang paghahanap",
    "clearAll": "I-clear lahat",
    "deleteHistory": "Burahin ang search history",
    "recommendedForYou": "Inirerekomenda para sa iyo",
    "loadMoreError": "Hindi ma-load ang iba pang produkto",
    "recommendationLoadError": "Hindi ma-load ang mga rekomendasyon"
  },
  "storesPage": {
    "title": "Listahan ng mga Tindahan",
    "emptyTitle": "Walang available na tindahan",
    "emptyDesc": "Wala pang available na tindahan sa lokasyong ito. Pakisubukan muli mamaya.",
    "statusOpen": "Bukas gaya ng dati",
    "statusUpgrading": "Ina-upgrade at Malapit Nang Magbukas",
    "unnamed": "Tindahan ng Genggo",
    "loadFailed": "Hindi ma-load ang mga tindahan",
    "retry": "Subukan muli",
    "dialFailed": "Hindi mabuksan ang phone dialer"
  },
  "faqPage": {
    "heroTitle": "Hi! Paano ka namin matutulungan?",
    "heroSubtitle": "Hanapin ang mga sagot sa karaniwang tanong tungkol sa aming device rental service.",
    "searchPlaceholder": "Maghanap ng mga tanong…",
    "noResults": "Walang nahanap na katugmang tanong",
    "contactTitle": "Hindi makita ang sagot?",
    "contactDesc": "Handang tumulong ang aming support team sa iba mo pang tanong.",
    "contactSupport": "Makipag-ugnayan sa Support",
    "helpfulQuestion": "Nakatulong ba ang impormasyong ito?",
    "helpfulYes": "Oo, nakatulong ito",
    "helpfulNo": "Hindi, kailangan ko pa ng tulong",
    "helpfulYesToast": "Masaya kaming nakatulong."
  },

  "goodsPage": {
    "title": "Mga Detalye ng Produkto", // 商品详情页标题
    "shippingAddress": "Address ng Pagpapadala",
    "addressLoadFailed": "Hindi ma-load ang iyong mga address. Pakisubukan muli.",
  },
  "skuPop": {
    "chooseVariant": "Choose Variant",
    "selection": "Selection",
    "noSelection": "No selection",
    "noSelectAttr": "Mangyaring pumili ng {attrName}", // 没有选择sku提示
    "noSelect": "Mangyaring pumili ng sku", // 没有选择sku提示
    "noStock": "Walang Stock",// 没有库存提示
  },
  "addressPop": {
    "add": "Magdagdag ng Bagong Address",
    "name": "Pangalan",
    "phone": "Numero ng Telepono",
    "region": "Rehiyon",
    "detail": "Address",
    "regionsPlaceholder": "Mangyaring pumili ng iyong rehiyon", // 区域选择市列提示
    "deleteTitle": "Burahin ang Address",  // 删除地址标题
    "deleteConfirm": "Sigurado ka bang burahin ang address na ito?", // 删除地址确认
    'regionEmpty': "Mangyaring pumili ng iyong rehiyon", // 区域选择为空提示
    "phoneEmpty": "Pakilagay ang iyong numero ng telepono",// 手机号为空提示
    "detailEmpty": "Pakilagay ang iyong address", // 地址为空提示
    "nameEmpty": "Pakilagay ang iyong pangalan", // 姓名为空提示
    "phoneError": "Pakilagay ng wastong Indonesia phone number",// 手机号格式错误提示
    "noSelectAddress": "Mangyaring pumili ng iyong address",// 没有选择地址提示
  },

  "contactPop": {
    "title": "Magdagdag ng Contact",
    "listTitle": "Mga Reference Contact",
    "editTitle": "I-edit ang Contact",
    "subTitle": "Para sa ligtas at panatag na paggamit, magdagdag ng emergency contact.",
    "selectRequired": "Pumili ng {count} reference contact | Pumili ng {count} reference contact",
    "contactTitle": "Contact Person {index}",
    "relation": "Relasyon",
    "name": "Pangalan",
    "phone": "Numero ng Telepono",
    "submit": "Save",
    "addNewContact": "Add New Contact",
    "relationEmpty": "Please select contact person's relationship",
    "nameEmpty": "Pakilagay ang pangalan ng contact person",
    "nameFormat": "Pakilagay ang wastong pangalan ng contact person",
    "phoneError": "Pakilagay ng wastong Indonesia phone number", // 手机号格式错误提示
    "phoneRepeat": "Ang phone number ng bawat contact ay dapat magkaiba (hindi maaaring magkapareho).", // 手机号重复
    "selectedCount": "Napili ang {selected} sa {count}",
    "empty": "Walang naka-save na contact",
    "addAnother": "Magdagdag ng contact",
    "maxCount": "Hanggang {count} contact lang ang maaaring piliin",
    "deleteTitle": "Tanggalin ang contact",
    "deleteConfirm": "Sigurado ka bang tatanggalin ang contact na ito?",
  },


  "myPage": {
    "title": "Profile",// 我的页面标题
    "rentalPlan": "Plano ng Upahan", // 我的页面租借计划标题
    "orderList": "Listahan ng Order", // 我的页面订单列表标题
    "additionalInfo": "Aking Impormasyon",
    "overdue": "Overdue", // 我的页面逾期标题
    "payNow": "Magbayad Ngayon", // 我的页面自己还款按钮
    "logoutTitle": "Mag-logout", // 我的页面登出标题
    "logoutContent": "Sigurado ka bang gusto mong mag-logout?", // 我的页面登出内容
    "guest": "Bisita",
    "loginRequiredTitle": "Kailangan mag-login",
    "loginRequiredContent": "Kailangan mong mag-login para magpatuloy.",
  },
  "accountPage": {
    "title": "Aking Account",
    "avatar": "Avatar",
    "guestUser": "Guest User",
    "verifiedMember": "Na-verify na Miyembro",
    "unverifiedMember": "Hindi Na-verify na Miyembro",
    "memberSince": "Miyembro mula {date}",
    "memberSinceEmpty": "Miyembro mula —",
    "loginDescription": "Kailangan mong mag-login para magpatuloy.",
    "shortcutsAriaLabel": "Mga shortcut ng account",
    "myOrders": "Mga Order Ko",
    "myBills": "Mga Bill Ko",
    "myInformation": "Aking Impormasyon",
    "myInformationDescription": "Pamahalaan ang iyong personal na impormasyon",
    "addressesContacts": "Mga Address at Contact",
    "addressesContactsDescription": "Pamahalaan ang delivery address at mga contact",
    "paymentMethods": "Mga Paraan ng Pagbabayad",
    "paymentMethodsDescription": "Pamahalaan ang iyong mga auto-debit account",
    "faqDescription": "Hanapin ang sagot sa mga karaniwang tanong",
    "settings": "Mga Setting",
    "settingsDescription": "Mga setting ng account at app",
    "supportDescription": "Humingi ng tulong mula sa aming support team",
    "loadFailed": "Hindi ma-load ang impormasyon ng account"
  },
  "paymentMethods": {
    "title": "Mga Auto-debit Account",
    "description": "Pamahalaan ang mga account na inawtorisahan para sa awtomatikong bayad sa renta.",
    "addTitle": "Magdagdag ng auto-debit account",
    "addDesc": "I-awtorisa ang isang payment account para sa awtomatikong bayad sa renta.",
    "addAccount": "Magdagdag ng account",
    "loadFailed": "Hindi ma-load ang mga auto-debit account",
    "authorizedAt": "Inawtorisa noong {time}",
    "unauthorizedAt": "Hindi awtorisado noong {time}",
    "cancelAuthorization": "Kanselahin ang awtorisasyon",
    "reauthorize": "I-reauthorize",
    "cancelTitle": "Kanselahin ang awtorisasyon",
    "cancelDesc": "Sigurado ka bang gusto mong kanselahin ang awtorisasyong ito?",
    "cancelSuccess": "Nakansela ang awtorisasyon",
    "status": {
      "active": "Aktibo",
      "pending": "Naghihintay",
      "expired": "Nag-expire",
      "disconnected": "Hindi Aktibo"
    }
  },
  "addressContacts": {
    "addresses": "Mga Address",
    "contacts": "Mga Contact",
    "addContact": "Magdagdag ng Contact",
    "goAdd": "Magdagdag ngayon",
    "emptyAddresses": "Wala pang naka-save na address",
    "emptyAddressesDesc": "Magdagdag ng delivery address para mas mabilis ang checkout.",
    "emptyContacts": "Wala pang naka-save na contact",
    "emptyContactsDesc": "Magdagdag ng reference contacts para sa iyong rental orders.",
    "contactUsageNotice": "Maaari lang namin silang kontakin kung hindi ka namin maabot para sa identity confirmation, delivery, device return, o safety-related matters. Hindi namin ibubunyag ang iyong bill, payment, o rental status.",
    "setDefaultAddressTitle": "Gawing default address",
    "setDefaultAddressConfirm": "Sigurado ka bang gawing default ang address na ito?"
  },
  "accountSettings": {
    "title": "Mga Setting",
    "agreementsPolicies": "Mga Kasunduan at Patakaran",
    "noAgreements": "Walang available na kasunduan",
    "noAgreementContent": "Wala pang nilalaman ang kasunduan.",
    "userRegistrationAgreement": "Kasunduan sa Pagpaparehistro ng User",
    "privacyPolicy": "Patakaran sa Privacy",
    "dataProcessingConsent": "Pahintulot sa Pagproseso ng Personal na Data",
    "deviceRentalAgreement": "Kasunduan sa Pag-upa ng Device",
    "accountDeleteAgreement": "Kasunduan sa Pag-delete ng Account",
    "aboutUs": "Tungkol sa Amin",
    "accountSecurity": "Account at Seguridad",
    "deleteAccount": "I-delete ang Account",
    "loadFailed": "Hindi ma-load ang mga setting"
  },
  "aboutUs": {
    "description": "Ang Genggo ay isang smart device rental platform\nna nagbibigay ng de-kalidad na device\nat maaasahang serbisyo sa mga customer\nsa buong mundo.\nLayunin naming gawing mas accessible\nat maginhawa ang teknolohiya para sa lahat.",
    "officialWebsite": "Opisyal na Website",
    "contactUs": "Makipag-ugnayan sa Amin",
    "openFailed": "Walang app na maaaring magbukas ng link na ito"
  },
  "deleteAccount": {
    "title": "I-delete ang Account",
    "confirmTitle": "Gusto mo bang i-delete ang iyong account?",
    "confirmDescription": "Hindi na ito maaaring bawiin. Basahin nang mabuti ang impormasyon sa ibaba.",
    "noteTitle": "Paalala",
    "noteOrder": "Kung mayroon kang kasalukuyang device rental order, hindi mo maaaring i-delete ang iyong account.",
    "noteData": "Kapag na-delete ang iyong account, permanenteng aalisin ang lahat ng iyong data at impormasyon at hindi na ito maibabalik.",
    "smsTitle": "I-verify gamit ang SMS Code",
    "smsDescription": "Magpapadala kami ng verification code sa iyong nakarehistrong mobile number.",
    "codePlaceholder": "Ilagay ang SMS code",
    "getCode": "Kunin ang Code",
    "codeCountdown": "{seconds}s",
    "codeValidTip": "Valid ang code sa loob ng 5 minuto.",
    "agreementPrefix": "Nabasa ko at sumasang-ayon ako sa ",
    "agreementName": "Kasunduan sa Pag-delete ng Account",
    "agreementRequired": "Sumang-ayon muna sa Kasunduan sa Pag-delete ng Account",
    "submitConfirmTitle": "I-delete ang account?",
    "submitConfirmDescription": "Pagkatapos kumpirmahin, ide-delete ang iyong account at mala-log out ka. Hindi na ito maaaring bawiin.",
    "codeFailed": "Hindi naipadala ang verification code",
    "successTitle": "Na-delete na ang iyong account",
    "successDescription": "Na-delete na ang iyong app account. Maaaring panatilihin ang ilang rekord ng order, bayad, kontrata, buwis, pag-iwas sa pandaraya, at dispute para sa mga legal o lehitimong pangangailangan ng negosyo gaya ng inilalarawan sa aming Patakaran sa Privacy at Patakaran sa Pag-delete ng Account.",
    "goHome": "Pumunta sa Home",
    "failed": "Hindi na-delete ang account"
  },



  "orderPage": {
    "orderTitle": "Detalye ng Order", // 订单详情页面标题
    "confirmTitle": "Kumpirmasyon ng Order",  // 订单确认页面标题
    "reviewRentalPlan": "Suriin ang Rental Plan",
    "orderSafeTitle": "Ligtas at protektado ang iyong order",
    "orderSafeSubtitle": "Unsecured parcel • Mga na-verify na seller • Proteksyon ng buyer",
    "agreementTitle": "Kasunduan",
    "choosePaymentMethod": "Pumili ng Paraan ng Pagbabayad",
    "amountDueToday": "Halagang Dapat Bayaran Ngayon",
    "initialPaymentAmount": "Initial Payment Amount",
    "rentalStartDate": "Oras ng Simula", // 订单详情页面租借开始日期标题
    "returnDate": "Oras ng Pagtatapos", // 订单详情页面租借结束日期标题
    "rentalStartDateDetail": "Petsa ng Simula ng Renta",
    "returnDateDetail": "Petsa ng Pagtatapos ng Renta",
    "rentalDateEstimated": "Tinatayang",
    "total": "Kabuuan",  // 订单详情页面总价标题
    "deposit": "Deposito",// 订单详情页面押金标题
    "refundableParenthetical": "(Maaaring I-refund)",
    "rentalTerm": "Panahon ng pagrenta",
    "amountPaid": "Halagang Nabayaran",
    "amountDueBeforePickup": "Halagang Dapat Bayaran Bago Kunin",
    "rent": "Upa", // 订单详情页面每期租金标题
    "periodicRent": {
      "WEEKLY": "Lingguhang Upa",
      "BI_WEEKLY": "Dalawang Linggong Upa",
      "MONTHLY": "Buwanang Upa"
    },
    "rentCycleUnit": {
      "WEEKLY": "linggo",
      "BI_WEEKLY": "2 linggo",
      "MONTHLY": "buwan"
    },
    "initialRent": "Unang Upa", // 订单详情页面首租金标题
    "remainingRent": "Natitirang Upa",  // 订单详情页面剩余租金标题
    "repaymentDate": "Petsa ng Pagbabayad",  // 订单详情页面还款日期标题
    "totalRentalPayments": "Kabuuang Pagbabayad ng Upa",
    "remainingAmountNoticeTitle": "Ang natitirang halaga ay sisingilin",
    "remainingAmountNoticeDesc": "Maaari mo itong bayaran sa susunod na buwan o mas huli.",
    "cancelledOrderNoPaymentTitle": "Walang naprosesong bayad",
    "cancelledOrderNoPaymentDesc": "Dahil nakansela ang order na ito, walang kailangang bayaran.",
    "cancelledOrderNeedHelpTitle": "Kailangan ng tulong?",
    "cancelledOrderNeedHelpDesc": "Kung mayroon kang mga tanong tungkol sa pagkanselang ito, makipag-ugnayan sa aming customer service team.",
    "rentalPeriodOngoingNoticeTitle": "Patuloy ang Panahon ng Pagrenta",
    "rentalPeriodOngoingNoticeDesc": "Nagsimula na ang panahon ng iyong pagrenta. Ingatan ang device at makipag-ugnayan sa amin kung may problema.",
    "paymentReceivedNoticeTitle": "Salamat! Natanggap na ang iyong bayad.",
    "paymentReceivedNoticeDesc": "Aabisuhan ka kapag naipadala na ang iyong order.",
    "payments": "mga pagbabayad",
    "contactTitle": "Contact",
    "addReferenceContacts": "Magdagdag ng Reference Contact",
    "noContacts": "Walang contact",
    "amount": "Halaga",
    "reasonPrefix": "Dahilan: ",
    "agText":"Nabasa ko at sumasang-ayon ako sa ",
    "agLastText":"at",
    "agreementCheckLabel":"Sumasang-ayon ako sa mga kasunduan sa itaas",
    "agreementRequired":"Mangyaring sumang-ayon muna sa Device Rental Agreement",
    "moreAgreements": "+{count} pa",
    "ownershipNoticeTitle":"Paunawa ng Pagmamay-ari",
    "ownershipNotice":"Kung ang lahat ng pagbabayad ng upa at iba pang halagang babayaran ay ganap nang nabayaran, at walang natitirang default, ang device ay magiging iyo sa pagtatapos ng panahon ng pag-upa. Hindi kinakailangan ang pagbabalik ng device pagkatapos ng paglipat ng pagmamay-ari.",
    "importantNotesTitle":"Mahalagang Paalala",
    "importantNotes1":"Kung tatapusin mo ang pag-upa pagkatapos maihatid ang device at bago makumpleto ang unang tatlong panahon ng pagbabayad ng upa, hindi na ibabalik ang security deposit at dapat ibalik ang device.",
    "importantNotes2":"Ang maagang pagtatapos ay maaari ring mangailangan ng pagbabayad ng natitirang upa, mga bayad sa huling pagbabayad, mga bayad sa maagang pagtatapos, mga gastos sa pagkumpuni, mga gastos sa pagpapalit, kompensasyon sa pagkawala ng device, at iba pang naaangkop na singil.",
    "importantNotes3":" Bayad sa huling pagbabayad: Rp30,000 bawat araw, simula sa susunod na araw ng kalendaryo pagkatapos ng takdang petsa.",
    "createdDate": "Petsa ng Paggawa",  // 订单详情页面创建日期标题
    "paymenDate": "Petsa ng Pagbabayad", // 订单详情页面支付日期标题
    "orderNumber": "Numero ng Order", // 订单详情页面订单编号标题
    "closeDate": "Petsa ng Pagsara",
    "closeReason": "Dahilan ng pagkansela",
    "paymentTimeoutCancelReason": "Payment timed out and the order was closed automatically",
    "userCancelledCloseReason": "Cancelled by user",
    "cancelledOnFormat": "Nakansela noong {time}",
    "orderCancelledDesc": "Nakansela ang order na ito.",
    "checkout": "Confirm & Continue",   // 订单详情页面去结算按钮
    "checkoutHint": "No payment is required now. You’ll choose COD or online payment after ID verification.",
    "payNow": "Magbayad Ngayon",
    "pendingPaymentTimeLimitDesc": "Please complete the payment within the time limit.",
    "payUrlTitle": "Magpatuloy sa Pagbabayad",
    "payUrlDesc": "Kumpletuhin ang pagbabayad sa page ng payment provider, pagkatapos ay bumalik dito upang tingnan ang resulta.",
    "goToPay": "Pumunta sa Pagbabayad",
    "paymentCompletedButton": "Nakumpleto Ko Na ang Pagbabayad",
    "paymentNotCompleted": "Hindi pa nakukumpleto ang pagbabayad.",
    "orderExpired": "Expired na ang Order",
    "planTips": "Paunawa: Ang petsa ng simula ng upahan ay nakabatay sa aktwal na oras ng paghahatid.", // 订单详情页面租借计划提示
    "rentalStartAdjusted": "Ang petsa ng simula ng renta ay ina-adjust sa aktwal na petsa ng paghahatid.",
    "rentalPlan": "Plano ng Upa",
    "rentalPeriodPlan": "Plano ng Panahon ng Pagrenta",
    "repayPlanPeriodFormat": "{period}{suffix}",
    "repayPlanDueDate": "Petsa ng Takdang Bayad sa Renta",
    "repayPlanAmount": "Halaga",
    "repayPlanAutoChargeTitle": "Mangyaring bayaran ang upa bago ang takdang petsa.",
    "repayPlanAutoChargeDesc": "",
    "orderSuccess": "Tagumpay ang Order", // 订单详情页面订单成功提示
    "orderFailed": "Nabigo ang Order",// 订单详情页面订单失败提示
    "addressTip": "Mangyaring pumili ng iyong address", // 订单详情页面请选择地址提示
    "contactTip": "Mangyaring punan ang emergency contact person",
    "payStatus": { // 订单详情页面订单状态头部提示
      "waitingPayment": 'Nakabinbing Pagbabayad', // 待付款
      "success": 'Tagumpay ang Pagbabayad', // 支付成功
      "closed": 'Tagumpay ang Pagbabayad',  // 支付取消
    },
    "payErrorTip": "Nabigo ang order, mangyaring subukan muli mamaya", // 订单详情页面订单失败提示
    "checkoutTitle": "Checkout",
    "payMethodTitle": "Payment Method",
    "onlinePaymentTitle": "Online Payment",
    "onlineOptionTitle": "Pay Now (QRIS)",
    "onlineOptionDesc": "Scan the QR code for fast payment",
    "onlinePayQrisTitle": "QRIS Online Payment",
    "onlinePayQrisDesc": "Scan QR for fast payment",
    "onlinePayAggregatedTitle": "Aggregated Online Payment",
    "onlinePayAggregatedDesc": "Choose your preferred method securely",
    "codOptionTitle": "Cash on Delivery (COD)",
    "codOptionDesc": "Pay when the order is received",
    "storeOptionTitle": "Offline Pickup",
    "storeOptionDesc": "Pay at the store when you pick up your device",
    "storePickupOnly": "Only this method supports in-store pickup",
    "pickupStoreTitle": "Choose a pickup store",
    "storeEmpty": "No pickup stores are available",
    "storeLoadFailed": "Failed to load stores",
    "storeRequired": "Please choose a pickup store",
    "checkoutStore": "Confirm Order",
    "storeVerifyPhoneTitle": "Offline Pickup Order Verification",
    "storeVerifyPhoneDesc": "For your security, a verification code is required to continue with the offline pickup order.",
    "storeConfirmOrder": "Confirm Order",
    "offlineSuccessNavTitle": "Order Submitted",
    "offlineSuccessTitle": "Your order has been submitted",
    "offlineSuccessDesc": "We've received your rental application. Please wait for our review. After approval, you can pick up the phone at the selected store.",
    "storeDetailsTitle": "Store Details",
    "offlineSuccessStoreLabel": "Store",
    "storeHours": "Opening Hours",
    "storePhone": "Store Phone",
    "offlineNextTitle": "What happens next",
    "offlineNextReview": "We will review your application. You will receive a notification once it’s approved.",
    "offlineNextPickup": "After approval, please go to the store during operating hours to pick up the phone.",
    "codRecommended": "Recommended",
    "codNotice": "By choosing COD, please prepare exact change when the courier delivers the order.",
    "codShippingFee": "COD Service Fee",
    "dueAfterApproval": "Due after approval",
    "dueOnDelivery": "Due on delivery",
    "amountDueOnApproval": "Amount Due on Approval",
    "codShippingFeePaid": "COD Service Fee Paid",
    "amountDueOnDelivery": "Amount Due on Delivery",
    "awaitingApproval": "Awaiting approval",
    "awaitingApprovalDesc": "Your order is being reviewed. We will notify you once it is approved.",
    "codShippingFeeNoticeTitle": "COD orders require a COD service fee",
    "codShippingFeeNoticeDesc": "This fee is payable after your order is approved. We will ship your order only after payment is successful.",
    "codShippingFeeNoticeRefund": "COD Service Fee is non-refundable for customer-related cancellations or delivery failures.",
    "payCodShippingFee": "Pay COD Service Fee",
    "checkoutOnline": "Confirm & Pay",
    "checkoutCod": "Order with COD",
    "codVerifyPhoneTitle": "Verify Your Phone Number",
    "codVerifyPhoneDesc": "For your security, a verification code is required to continue with COD.",
    "codPhoneLabel": "Phone",
    "codVerificationCode": "Verification Code",
    "codVerificationCodePlaceholder": "Enter 6-digit code",
    "codGetCode": "Get Code",
    "codCodeCountdown": "{seconds}s",
    "codCodeTip": "The verification code will be sent via WhatsApp (WA) or SMS.",
    "codConfirmOrder": "Confirm Order",
    "codPhoneMissing": "Phone number is unavailable, please log in again",
    "codCodeSent": "Verification code sent",
    "codCodeSendFailed": "Failed to send verification code",
    "codCodeRequired": "Please enter the 6-digit verification code",
    "codSuccessTitle": "Matagumpay na Naisumite ang Order",
    "codSuccessDesc": "Nakumpirma na ang iyong Cash on Delivery order. Mangyaring ihanda ang bayad kapag naihatid ang device.",
    "codSuccessCardTitle": "Cash on Delivery",
    "codSuccessCardDesc": "Mangyaring ihanda ang Rp{amount} kapag naihatid ang device. Kokolektahin ng courier ang bayad bago ibigay ang device.",
    "codSuccessShippingFeeNoticeDesc": "After the order is approved, please pay the COD Service Fee online. The order will be shipped immediately after the payment is successful.",
    "codDeliveryReminderBefore": "Please prepare",
    "codDeliveryReminderAfter": "when the device is delivered. The device will be handed over after payment is completed.",
    "dueOnApproval": "Due on approval",
    "backToHome": "Bumalik sa Home",
    "viewOrder": "Tingnan ang Order",
    "codLabel": "COD",
    "codAmountTitle": "Halagang Babayaran sa Delivery",
    "codPaymentReminder": "Paalala sa COD Payment",
    "codPaymentReminderIntro": "Pinili mo ang Cash on Delivery (COD).",
    "codPaymentReminderDesc": "Mangyaring ihanda ang Rp{amount} kapag naihatid ang device. Ibibigay ang device pagkatapos ng bayad.",
    "codReminder": "Mangyaring ihanda ang Rp{amount} kapag naihatid ang device.",
    "pay": "Magbayad",
    "payAtStore": "Magbayad bago kunin",
    "storePaymentReminder": "Offline Pickup Reminder",
    "storePaymentReminderDesc": "Please go to the selected store and pay the amount due on delivery. After the payment is completed, you can pick up the device at the store.",
    "storePickupReminderTitle": "Pickup Reminder",
    "storePickupReminderDesc": "Your first rental payment and security deposit have been paid successfully. Please visit the selected store as soon as possible to pick up your phone.",
    "paymentDateCod": "Petsa ng Pagbabayad (COD)",
    "cancelOrder": "Kanselahin ang Order",
    "statusPaymentCompleted": "Nakumpleto ang Pagbabayad",
    "statusAwaitingShipment": "Naghihintay ng Pagpapadala",
    "statusAwaitingDelivery": "Naghihintay ng Paghahatid",
    "viewLogisticsProgress": "Tingnan ang Progreso ng Logistics",
    "statusDelivered": "Naihatid na",
    "statusInRental": "Kasalukuyang Nirentahan",
    "awaitingShipmentDesc": "Your order is confirmed and waiting for shipment.",
    "approvedAwaitingShipmentDesc": "Your order has been approved and is being prepared for shipment. Tracking information will be available once shipped.",
    "awaitingDeliveryDesc": "Your order is on the way. Please confirm receipt when you receive the package.",
    "orderedOnFormat": "Ordered on {time}",
    "paidOnFormat": "Paid on {time}",
    "deliveredOnFormat": "Delivered on {time}",
    "deliveredDescription": "Your device has been delivered. Your rental period has started.",
    "refundedNotice": "Ire-refund ang bayad sa loob ng 5 business days.",
    "importantNotes": "Mahalagang Paalala",
    "belanjaAmanTitle": "Rent safely and conveniently",
    "belanjaAmanDesc": "Your payment is protected; pay when the device arrives.",
    "codShippingFeeCheckoutSafeTitle": "Transaction secure & encrypted",
    "codShippingFeeCheckoutTitle": "COD Service Fee",
    "onlineBelanjaAmanDesc": "Your payment is protected; pay when the device arrives.",
    "transaksiAman": "Ligtas at naka-encrypt na transaksyon",
    "rincianPesanan": "Mga Detalye ng Order",
    "lihatRincian": "Tingnan ang Detalye",
    "totalPembayaran": "Kabuuang Bayad",
    "securityDeposit": "Security Deposit",
    "initialRentalPayment": "Unang Bayad sa Upa",
    "firstRentalPayment": "First Rental Payment",
    "firstRentalAmount": "Unang Halaga ng Upa",
    "firstMonthRentSecurityDeposit": "Unang halaga ng renta + security deposit",
    "remainingRentalPayments": "{count} payments * {price}",
    "rentalFrequency": "Dalas ng Upa",
    "totalRentalPaymentsCheckout": "Kabuuang Pagbabayad ng Upa",
    "additionalInfoBannerTitle": "Magsumite ng karagdagang impormasyon para sa mas mabilis na pagpapadala.",
    "additionalInfoBannerDesc": "Ang pagbibigay ng mas maraming dokumento ay makakatulong sa amin na iproseso at maipadala ang iyong order nang mas mabilis.",
    "returningTitle": "Ibinabalik",
    "returnInProgress": "Isinasagawa ang Pagbabalik",
    "returningDescription": "Pakibalik ang device sa petsa ng pagtatapos. Susuriin namin ito pagkatapos naming matanggap.",
    "returnCompletedTitle": "Nakumpleto ang Pagbabalik",
    "returnCompletedDescription": "Salamat! Natanggap at nasuri na namin ang device. Kumpleto na ang order na ito.",
    "orderSuccessCompletedDescription": "Nakumpleto na ang bayad. Tapos na ang iyong rental. Salamat sa iyong order!",
    "deliveryAddress": "Address ng Paghahatid",
    "referenceContacts": "Mga Reference Contact",
    "contactsAdded": "{count} contact ang naidagdag | {count} contact ang naidagdag",
    "product": "Produkto",
    "rentalDates": "Mga Petsa ng Renta",
    "pricePlan": "Plano ng Presyo",
    "copyOrderNumber": "Kopyahin ang order number",
    "copySuccess": "Nakopya ang order number",
    "copyFailed": "Hindi nakopya",
    "backToOrders": "Bumalik sa Mga Order",
    "whatsapp": "WhatsApp",
    "paid": "Paid",
  },


  "orderList": {
    "title": "Listahan ng Order", // 订单列表页面标题
    "myOrders": "Aking mga Order",
    "orderNo": "Order No. {id}",
    "copySuccess": "Nakopya ang order number",
    "filters": { "all": "Lahat", "active": "Aktibo", "breaching": "Ibinabalik", "completed": "Nakumpleto", "closed": "Sarado" },
    "deposit": "Bawat Installment",// 订单列表页面押金标题
    "preInstallment": "Bawat Installment", // 订单列表页面分期标题
    "empty": "Wala pang order", // 订单列表页面没有订单提示
    "emptyDesc": "Dito lalabas ang iyong mga rental order kapag nakapag-place ka na ng order.",
    "shopNow": "Mamili ngayon",
    "cancelSuccess": "Nakansela ang Order", // 取消订单成功提示
    "cancelFailed": "Nabigo ang pagkansela ng order", // 取消订单失败提示
    "cancelTitle": "Kanselahin ang Order", // 订单列表页面取消订单标题
    "cancelContent": "Sigurado ka bang gusto mong kanselahin ang order na ito?",
    "cancelRefundDesc": "Pakikumpirma ang iyong pagkansela. Pagkatapos maaprubahan, isasara ang order at ire-refund ang kwalipikadong halaga sa account na ibibigay mo.",
    "cancelBackTrackDesc": "Pakikumpirma ang iyong pagkansela. Pagkatapos maaprubahan, ibabalik ang kwalipikadong halaga sa orihinal na paraan ng pagbabayad.",
    "cancelCodDesc": "Sigurado ka bang gusto mong kanselahin ang order na ito? Hindi na ito mababawi pagkatapos isumite.",
    "orderAmount": "Halaga ng Order",
    "cancelRefundAmount": "Halaga ng Refund",
    "cancelReason": "Dahilan ng Pagkansela", // 取消理由
    "cancelReasonPlaceholder": "Mangyaring ilarawan ang dahilan ng pagkansela",
    "keepOrder": "Panatilihin ang Order",
    "codCancelNoticeTitle": "Cash on Delivery (COD) Order",
    "codCancelNoticeDesc": "You have not made any payment yet. No refund will be issued for this cancellation.",
    "refundAccount": "Refund Account",
    "refundAccountNotice": "The refund will be sent to this account within 3-5 business days after the cancellation is confirmed.",
    "refundType": "Paraan ng Refund",
    "refundTypeEmpty": "Mangyaring pumili ng paraan ng refund",
    "bankCard": "Bank Card",
    "virtualAccount": "Virtual Account",
    "eWallet": "E-Wallet",
    "bankName": "Pangalan ng Bangko",
    "selectBankPlaceholder": "Mangyaring pumili ng bangko",
    "selectVAPlaceholder": "Mangyaring pumili ng virtual account",
    "selectEWalletPlaceholder": "Mangyaring pumili ng e-wallet",
    "bankEmpty": "Mangyaring pumili ng bangko",
    "accountNo": "Numero ng Account",
    "accountNoPlaceholder": "Mangyaring ilagay ang numero ng account",
    "accountNoEmpty": "Mangyaring ilagay ang numero ng account",
    "accountName": "Pangalan ng may-ari ng account",
    "accountNamePlaceholder": "Mangyaring ilagay ang pangalan ng may-ari ng account",
    "accountNameEmpty": "Mangyaring ilagay ang pangalan ng may-ari ng account",
    "accountNoError": "Hindi wasto ang format ng numero ng account",
    "accountNameError": "Ang pangalan ng account ay naglalaman ng hindi wastong mga character",
    "logistics": {
      "deliveryProgress": "Progreso ng Paghahatid:",
      "paymentCompleted": "Nakumpleto ang Pagbabayad, Naghihintay ng Pagpapadala",
      "shipped": "Naipadala, Naghihintay ng Paghahatid",
      "delivered": "Naihatid (Nakalagda)",
      "preparingShipment": "Natanggap na ang iyong bayad. Inihahanda ang item para sa pagpapadala.",
      "logistics": "Ang iyong item ay naipadala na at nasa daan na.",
      "awaitingShipment": "Naghihintay ng pagpapadala",
      "awaitingReceipt": "Naghihintay ng pagtanggap",
      "signed": "Naihatid"
    },
    "cancelStatus": {
      "titlePending": "Hiniling ang Pagkansela",
      "titleApproved": "Na-refund",
      "titleRejected": "Tinanggihan ang Pagkansela",
      "subtitleUnderReview": "Sinusuri",
      "descReviewing": "Sinusuri namin ang iyong kahilingan sa pagkansela.",
      "descRefunded": "Ang bayad ay ire-refund sa loob ng 5 araw ng negosyo.",
      "appliedOnFormat": "Inapply noong {time}",
      "approvedOnFormat": "Naaprubahan noong {time}",
      "rejectedOnFormat": "Tinanggihan noong {time}",
      "rejectReasonFormat": "Dahilan ng Pagtanggi: {reason}",
      "contactService": "Kung mayroon kang anumang tanong, mangyaring makipag-ugnayan sa customer service.",
      "withdrawRequest": "Bawiin ang Kahilingan",
      "withdrawTitle": "Bawiin ang kahilingang ito?",
      "withdrawContent": "Sigurado ka bang gusto mong bawiin ang iyong kahilingan sa pagkansela?",
      "withdrawSuccess": "Nabawi ang kahilingan sa pagkansela"
    },
    "paymentDeadline": {
      "prefix": "Kumpletuhin ang pagbabayad bago ang ",
      "suffix": "upang maiwasan ang awtomatikong pagkansela."
    },
    "status": {
      "waitingPay": 'Awaiting Payment', // 待支付
      "underLease": 'In Rental', // 租赁中
      "completed": 'Completed', // 已完成
      "closed": 'Cancelled', // 已关闭
      "breach": 'Completed', // 已退租
      "breaching": 'Return in Process', // 退租处理中
    },
    "options": {
      "cancel": "Kanselahin", // 取消
      "orderDetail": "Mga Detalye ng Order", // 订单列表页面订单详情按钮
      "rentalPlan": "Plano ng Upahan", // 订单列表页面租借计划按钮
      "deliveryProgress": "Pag-delivery", // 订单列表页面订单物流信息按钮
      "payNow": "Go to Pay",
      "terminalDetail": "Detalye ng Pagbabalik"
    }
  },




  "express": {
    "title": "Express", // 物流信息标题
    "courier": "Courier",// 快递公司名称
    "trackingNumber": "Tracking number", // 物流信息物流单号标题
    "emptyTips": "Wala pang available na tracking impormasyon."
  },




  "login": {
    "title": "Mag-login", // 登录页面标题
    "registerTips": "Kung hindi ka nakarehistro, awtomatiko kaming gagawa ng account at i-log in ka.",  // 登录页面注册提示
    "welcome_message": "Umupa ngayon,\n pagmamay-ari ito mamaya.", // 登录页面欢迎语
    "invalid_phone": "Pakilagay ng wastong Indonesia phone number",  // 登录页面手机号验证
    "countdown_text": "{seconds}s", // 登录页面倒计时提示
    "get_verification_code": "Kuha ng Code",  // 登录页面获取验证码按钮
    "phone_placeholder": "Ilagay ang Indonesia phone number",  // 登录页面手机号输入框提示
    "code_placeholder": "Ilagay ang verification code",  // 登录页面验证码输入框提示
    "login_button": "Login",  // 登录页面登录按钮
    "verification_sent": "Naipadala na ang verification code",  // 登录页面验证码发送成功提示
    "verification_failed": "Nabigong magpadala ng verification code", // 登录页面验证码发送失败提示
    "login_success": "Tagumpay ang Pag-login", // 登录页面登录成功提示
    "login_failed": "Nabigo ang pag-login, pakisuri ang iyong verification code", // 登录页面登录失败提示
    "agreement_required": "Pakisang-ayunan muna ang mga kasunduan",
    "subtitle_rent_to_own": "Phone rent-to-own ginawang simple",
    "feature_flexible": "Flexible na pagbabayad",
    "feature_trusted": "Mapagkakatiwalaan at ligtas",
    "feature_yours": "Iyong iyong panatilihin",
    "code_message": "Pakisuri ang iyong WhatsApp o SMS para sa verification code."
  },



  "payment": {
    "success": "Tagumpay ang Pagbabayad", // 支付成功标题
    "failed": "Nabigo ang Pagbabayad", // 支付失败标题
    "timeout": "Timeout sa Pagbabayad", // 支付超时标题
    "successSub": "Tagumpay ang pagbabayad, maghintay sa pagproseso ng system", // 支付成功提示
    "failedSub": "Nabigo ang pagbabayad, pakisubukan muli", // 支付失败提示
    "timeoutSub": "Timeout sa pagbabayad, pakisubukan muli", // 支付超时提示
    "paymentDetails": "Mga Detalye ng Pagbabayad", // 单词翻译
    "orderNumber": "Numero ng Order", // 单词翻译
    "paymentTime": "Oras ng Pagbabayad", // 单词翻译
    "total": "Kabuuanl",   // 支付结果页总价标题
    "deposit": "Deposito", // 支付结果页押金标题
    "rent": "Upa", // 支付结果页租金标题
    "insurance": 'Insurance', // 支付结果页保险标题
    "penalty": 'Multa', // 支付结果页违约金标题
    "return_damage": 'Pagbabayad.Pagbalik-Pinsala',
    "btnGoHome": "Bumalik sa Home", // 支付结果页按钮文案 翻译单词
    "btnReorder": "Muling Mag-order", // 支付结果页按钮文案 翻译单词
    "btnOrderList": "Listahan ng Order" // 支付结果页按钮文案 翻译单词
  },



  "cycle": { // 租借周期
    "WEEKLY": 'Lingguhan',   // 周
    "BI_WEEKLY": 'Dalawang Linggo', // 双周
    "MONTHLY": 'Buwanan' // 月
  },



  "rentalplan": {
    "title": "Mga Bill Ko", // 租赁列表标题
    "orderNumber": "Order No.", // 单词翻译
    "total": "Kabuuan", // 单词翻译
    "overdue": "Overdue", // 单词翻译
    "paid": "Paid",
    "unpaid": "Unpaid",
    "dueAmount": "Due Amount",
    "dueDate": "Due Date",
    "unknownProduct": "Unknown product",
    "payNow": "Magbayad Ngayon", // 还款按钮
    "installment": "Installment", // 单词翻译
    "upcoming": "Pending",
    "copyOrderNumber": "Kopyahin ang order number",
    "copySuccess": "Nakopya ang order number",
    "copyFailed": "Hindi nakopya",
    "empty": "Walang available na bill", // 列表为空提示
    "emptyDesc": "Dito lalabas ang mga paparating na bill sa upa at status ng pagbabayad.",
    "shopNow": "Mamili ngayon",
    "securePaymentNote": "Secure payments powered by trusted partners.",
  },



  "planDetail": { // 租赁详情页面
    "title": "Detalye ng Plano ng Upahan", // 租金详情页面标题
    "billDetails": "Detalye ng Bill",
    "copyOrderNumber": "Kopyahin ang numero ng order",
    "copySuccess": "Nakopya ang numero ng order",
    "copyFailed": "Hindi nakopya",
    "orderTime": "Oras ng order",
    "receivedTime": "Oras ng pagtanggap",
    "billTotalAmount": "Kabuuang Halaga",
    "billDueDate": "Takdang Petsa",
    "totalAmountDue": "Kabuuang Halagang Babayaran",
    "rentAmount": "Halaga ng Upa",
    "rentAmountThisPeriod": "Upa para sa panahong ito",
    "rentalPeriodCount": "Panahon ng upa",
    "payRentalBill": "Bayaran ang Rental Bill",
    "viewInstallmentPlan": "Tingnan ang Plano ng Panahon ng Upa",
    "viewInstallmentPlanDesc": "Tingnan ang iskedyul at halaga ng lahat ng panahon ng upa",
    "payOffRemainingRent": "Bayaran ang Natitirang Bayarin sa Upa",
    "payRemainingOptional": "Bayaran nang maaga ang lahat ng natitirang panahon ng upa (opsyonal)",
    "securePaymentNote": "Secure ang pagbabayad sa tulong ng trusted partners.",
    "payOffSecureNote": "Secure ang bayad at protektado ang iyong data.",
    "repayPlanMonthlyTipTitle": "Naka-iskedyul buwan-buwan ang iyong mga bayad sa renta.",
    "repayPlanMonthlyTip": "Kasama sa lahat ng halaga ang naaangkop na buwis.",
    "repayPlanPaymentTipTitle": "Mabubuo ang mga rental bill sa bawat takdang petsa.",
    "repayPlanPaymentTip": "Mangyaring magbayad sa oras upang maiwasan ang overdue fees.",
    "repayPlanEmpty": "Walang available na repayment plan",
    "repayPlanLoadFailed": "Hindi ma-load ang repayment plan",
    "applyForReturn": "Mag-apply para sa Pagbabalik",
    "returnDetails": "Mga Detalye ng Pagbabalik",
    "payOffIncludesNote": "Kasama rito ang lahat ng hindi pa bayad na upa at overdue penalty. Walang karagdagang penalty na sisingilin.",
    "remainingPeriods": "Natitirang panahon",
    "remainingRentalPeriods": "Natitirang Panahon ng Upa",
    "remainingRentOnePeriod": "Natitirang Upa ({count} Panahon ng Upa)",
    "remainingRentManyPeriods": "Natitirang Upa ({count} Panahon ng Upa)",
    "payAmountFormat": "Bayaran {amount}",
    "lateFeeForThisBill": "Late fee para sa bill na ito",
    "lateFeeRuleTitle": "Late Fee",
    "lateFeeRuleDesc": "{amount}/araw para sa bawat overdue na rental period.",
    "lateFeeInfo": "Maaaring magkaroon ng late fee pagkatapos ng takdang petsa.",
    "orderNumber": "Numero ng Order", // 单词翻译
    "totalDue": "Kabuuang Dapat Bayaran", // 单词翻译"
    "total": "Kabuuan", // 单词翻译
    "rent": "Upa", // 单词翻译
    "deposit": 'Deposito', // 单词翻译
    "lateFee": 'Late Fee', // 单词翻译
    "payOff": 'Bayaran ang Lahat', // 单词翻译
    "payNow": 'Magbayad Ngayon', // 还款页还款按钮
    "selectPrev": 'Pakisuri ang mga installment na nais mong bayaran, ayon sa pagkakasunod-sunod.', // 按顺序勾选提醒
    "selectOverdue": 'Para magpatuloy, mangyaring pumili at bayaran ang nakalipas na due na installment(s)', // 逾期勾选提醒
    "status": { // 还款页还款计划状态按钮显示
      "due": 'Dapat Bayaran', // 待还款
      "unpaid": 'Unpaid',
      "upcoming": 'Pending',
      "paid": 'Nabayaran', // 已还款
      "overdue": 'Overdue', // 逾期
    },
    "terminate": "Wakasan", // 终止按钮文案
    "paymentRulesTitle": "Mga Patakaran sa Pagbabayad",
    "paymentRules1": "Mangyaring kumpletuhin ang bawat pagbabayad sa o bago ang takdang petsa.",
    "paymentRules2": "Bayad sa huling pagbabayad: Rp30,000 bawat araw, simula sa susunod na araw ng kalendaryo pagkatapos ng takdang petsa.",
    "paymentRules3": "Ang mga huling pagbabayad ay maaaring magresulta sa mga paalala ng pagbabayad, paghihigpit sa account, o pansamantalang paghihigpit sa ilang hindi mahahalagang feature ng device, kung pinahihintulutan ng batas.",
    "paymentRules4": "Kung ang lahat ng pagbabayad ng upa at iba pang halagang babayaran ay ganap nang nabayaran, at walang natitirang default, ang pagmamay-ari ng device ay ililipat sa iyo sa pagtatapos ng panahon ng pag-upa.",
    "paymentRules5": "Ang maagang pagtatapos pagkatapos ng paghahatid at bago makumpleto ang unang tatlong panahon ng pagbabayad ng upa ay magreresulta sa hindi pagbabalik ng security deposit, at dapat ibalik ang device.",
  },
  "terminate": {
    "title": "Wakasan ang Lease", // 终止订单页面标题
    "detailsTitle": "Mga Detalye ng Pagtatapos",
    "confirmCont": "Sigurado ka bang nais mong itigil ang iyong renta maaga?", // 终止订单confrim提示
    "tips": "Pakitandaan na ang maagang pagwawakas ay maaaring magdulot ng karampatang bayarin.", // 终止订单费用提示
    "orderInfo": "Impormasyon ng Order",  // 终止订单页面订单信息标题
    "paymentDue": "Pagbabayad na Dapat Gawin", // 终止订单页面待还款标题
    "penaltyFee": "Bayad sa Maagang Pagtatapos", // 终止订单页面违约金标题
    "penaltyFeeHint": "I-tap ang tandang pananong sa itaas para makita kung paano kinakalkula ang penalty fee.",
    "paymentDueRuleTitle": "Pagbabayad na Dapat Gawin",
    "paymentDueRuleDesc": "15% ng natitirang upa ang ilalapat para sa maagang pagtatapos. Sa unang 3 panahon, hindi na ibabalik ang deposito.",
    "progress": "Pag-unlad", // 终止订单页面进度标题
    "express": "Impormasyon ng Pagpapadala", // 终止订单页面物流信息标题
    "expressNumber": "Tracking number", // 终止订单页面物流单号标题
    "expressCompany": "Kumpanya ng Pagsubaybay", // 终止订单页面物流单号标题
    "deposit": "Deposito", //终止订单页面押金标题
    "preInstallment": "Bawat Installment", // 终止订单页面分期标题
    "btnApply": "Ipadala ang Kahilingan", // 终止订单页面申请按钮
    "btnConfirm": "Kumpirmahin ang Pagtatapos",
    "btnReapply": "Mag-apply Muli", // 终止订单页面申请按钮
    "btnPay": "Magbayad Ngayon", // 终止订单页面申请按钮
    "btnExpress": "Ipadala ang Impormasyon ng Pagpapadala", // 终止订单页面申请按钮
    "applySuccess": "Tagumpay ang Pag-apply",  // 终止订单页面申请成功标题
    "expressSuccess": "Tagumpay ang Express na Pagpapasa",  // 终止订单页面申请成功标题
    "expressNumberTip": "Pakilagay ang tracking number", // 终止订单页面物流单号提示
    "expressCompanyTip": "Mangyaring pumili ng tracking company", // 终止订单页面物流公司提示
    "returnShippingDesc": "Pakibigay ang iyong return shipping details.",
    "trackingPlaceholder": "Ilagay ang tracking number",
    "selectShippingCompany": "Pumili ng shipping company",
    "submitConfirmTitle": "Kumpirmahin ang kahilingan sa pagtatapos?",
    "submitConfirmDesc": "Pagkatapos isumite, susuriin namin ang iyong kahilingan para sa maagang pagtatapos. Maaaring may bayarin at maaaring kailangan mong ibalik ang device.",
    "importantNotes": "Mahalagang Paalala",
    "paid": "Bayad",
    "paidTime": "Binayaran noong {time}",
    "earlyTerminationTitle": "Paunawa ng Maagang Pagtatapos ng Pag-upa",
    "earlyTerminationDesc": "Ikaw ay nag-a-apply upang wakasan ang iyong pag-upa nang maaga. Kung maaprubahan, dapat mong ibalik ang device ayon sa aming mga tagubilin sa pagbabalik.",
    "earlyTerminationDesc2": "Ang maagang pagtatapos ay maaaring mangailangan ng pagbabayad ng natitirang upa, mga bayad sa huling pagbabayad, mga bayad sa maagang pagtatapos, mga gastos sa pagkumpuni, mga gastos sa pagpapalit, kompensasyon sa pagkawala ng device, at iba pang naaangkop na singil.",
    "depositNoticeTitle": "Mahalagang Paunawa sa Deposito",
    "depositNoticeDesc": "Kung ang device ay naihatid na at winakasan mo ang pag-upa bago makumpleto ang unang tatlong panahon ng pagbabayad ng upa, hindi na ibabalik ang security deposit at dapat ibalik ang device.",
  },
  "additionalInfo": {
    "status": {
      "not-submitted": "Hindi Na-verify",
      "submitted": "Under review",
      "approved": "Na-verify"
    },
    "title": "Karagdagang Impormasyon", // 页面标题
    "submissionResultTitle": "Resulta ng Pagsusumite", // 页面标题
    "goHome": "Bumalik sa Home", // 返回首页按钮
    "submit": "Kumpirmahin at Isumite", // 提交按钮
    "submitSuccess": "Matagumpay na naisumite ang impormasyon", // 提交成功
    "submitFailed": "Nabigo ang pagsusumite, pakisubukan muli", // 提交失败
    "requiredDocumentsTip": "Paki-upload ang lahat ng kinakailangang dokumento bago magsumite",
    "uploadAtLeastOneTip": "Paki-upload ang kahit isang bagong dokumento",
    "driverLicensePairTip": "Paki-upload ang harap at likod ng lisensya sa pagmamaneho",
    "bpjsTkPairTip": "Paki-upload ang harap at likod ng inyong BPJS TK card",
    "fileTypeTip": "Paki-upload ang file sa isa sa mga format na ito: {formats}",
    "tipBanner": "Mangyaring panatilihing available ang inyong telepono. Maaaring kontakin kayo ng aming koponan kung kakailanganin ang karagdagang impormasyon.", // 底部提示
    "terms": {
      "title": "Mga Tuntunin sa Pagkolekta ng Data", // 条款标题
      "desc1": "Upang maproseso ang iyong rental application, kokolektahin at gagamitin namin ang mga dokumento at impormasyong isusumite mo, kabilang ang KTP, Family Card, larawan ng mukha, bank statement, payslip, impormasyon sa social media, at iba pang sumusuportang dokumento.", // 条款描述
      "desc2": "Ginagamit namin ang data na ito para sa identity verification, pagtatasa ng pagiging kwalipikado sa rental, pag-iwas sa panloloko, pagsusuri ng order, delivery, pamamahala ng bayad at overdue, at pagsunod sa batas.",
      "viewFull": "Tingnan ang buong tuntunin", // 查看完整条款
      "agreeText": "Nabasa ko at sumasang-ayon ako sa ", // 同意条款文案
      "notAgreedTip": "Mangyaring sumang-ayon muna sa mga tuntunin sa pagkolekta ng data" // 未同意条款提示
    },
    "upload": {
      "title": "Pag-upload ng Dokumento", // 文档上传标题
      "uploaded": "Nai-upload na", // 已上传状态
      "uploadedBankStatement": "Nai-upload na (nakaraang 3 buwan)",
      "success": "Matagumpay na nai-upload", // 上传成功
      "failed": "Nabigo ang pag-upload, pakisubukan muli", // 上传失败
      "fileTooLarge": "Lumampas ang laki ng file. Maximum: {size}MB" // 上传失败
    },
    "docs": {
      "familyCard": "KK (Family Card)", // 家庭卡
      "socialMedia": "Screenshot ng Social Media Account", // 社交媒体截图
      "bankStatement": "Bank Statement", // 银行账单
      "payslip": "Payslip / Katibayan ng Sahod", // 工资单
      "driverLicenseFront": "Lisensya sa Pagmamaneho (Harap)", // 驾驶证正面
      "driverLicenseBack": "Lisensya sa Pagmamaneho (Likod)", // 驾驶证背面
      "bpjsTkFront": "BPJS TK (Harap)",
      "bpjsTkBack": "BPJS TK (Likod)"
    },
    "submissionResult": {
      "title": "Matagumpay na Naisumite",
      "desc1": "Ang iyong mga dokumento ay matagumpay na naisumite.",
      "desc2": "Susuriin namin ang iyong impormasyon at aabisuhan ka kapag kumpleto na ang beripikasyon."
    }
  },
  "personalAdditionalInfo": {
    "title": "Aking Impormasyon",
    "basicVerification": "Pangunahing Beripikasyon",
    "identityVerification": "KTP at Pagkilala sa Mukha",
    "additionalDocuments": "Karagdagang Impormasyon",
    "intro": "Kumpletuhin ang iyong personal na impormasyon upang matulungan kaming i-verify ang iyong identidad at mas mabilis na maproseso ang iyong rental application.",
    "documentsDesc": "Mag-upload ng malinaw at wastong dokumento para sa iyong rental application.",
    "documentsTip": "Mag-upload ng malinaw at wastong dokumento. Ligtas at kumpidensyal na itatago ang lahat ng impormasyon.",
    "underReviewTip": "Matagumpay na naisumite ang iyong impormasyon.\nHindi mo kailangang hintayin ang resulta ng beripikasyon para makapag-order.",
    "readyTitle": "Malapit na!",
    "readyDesc": "Kumpleto na ang pangunahing beripikasyon. Suriin ang iyong impormasyon at isumite para sa pagsusuri.",
    "readyDocumentsTip": "Na-upload na ang lahat ng dokumento. Kumpirmahin at isumite para sa pagsusuri.",
    "reviewBeforeSubmit": "Maaari mong suriin o i-upload muli ang anumang dokumento bago magsumite.",
    "approvedTitle": "Na-verify na ang lahat ng impormasyon!",
    "approvedDesc": "Salamat! Matagumpay na na-verify ang iyong impormasyon. Maaari ka nang magpatuloy.",
    "rejectedTitle": "Nabigo ang Beripikasyon",
    "rejectedDesc": "Ang ilang impormasyong isinumite mo ay hindi nakatugon sa aming mga kinakailangan. Mag-upload muli.",
    "rejectedDocumentsTip": "Suriin ang dahilan ng pagtanggi sa bawat dokumento at mag-upload muli. Dapat malinaw, kumpleto, at wasto ang lahat ng dokumento.",
    "rejectedDocumentDesc": "Hindi malinaw o hindi kumpleto ang dokumento.",
    "reupload": "Mag-upload muli",
    "uploading": "Ina-upload…",
    "verifying": "Isinasagawa ang verification...",
    "verify": "Pumunta sa sertipikasyon",
    "upload": "Mag-upload",
    "confirmSubmit": "Kumpirmahin at Isumite",
    "protectedText": "Protektado ang iyong impormasyon at gagamitin lamang para sa verification.",
    "notVerified": "Hindi Na-verify",
    "loadFailed": "Hindi ma-load ang impormasyon. Pakisubukan muli.",
    "retry": "Subukan muli",
    "submissionSuccessTitle": "Matagumpay na naisumite ang impormasyon",
    "submissionSuccessDesc": "Natanggap na namin ang iyong mga dokumento.\nMangyaring maghintay habang sinusuri namin ang iyong impormasyon.",
    "whatNextTitle": "Ano ang susunod?",
    "whatNextDesc": "Maaari ka nang tumingin at mag-apply para sa gusto mong rental device. Aabisuhan ka namin kung kailangan pa ng karagdagang impormasyon.",
    "needHelpTitle": "Kailangan ng tulong?",
    "needHelpDesc": "Makipag-ugnayan sa aming customer support team.",
    "avoidRejectionTitle": "Mga tip upang maiwasan ang pagtanggi",
    "avoidRejectionDesc": "• Tiyaking orihinal at hindi in-edit ang lahat ng dokumento.\n• Kumuha ng malinaw na larawan sa maliwanag na lugar.\n• Tiyaking buong nakikita ang lahat ng teksto at gilid.",
    "basic": {
      "loading": { "title": "Naglo-load", "desc": "Nilo-load ang iyong verification status." },
      "verified": { "title": "Na-verify ang identidad", "desc": "Na-verify na ang iyong identidad." },
      "unverified": { "title": "Kailangan ng identity verification", "desc": "I-verify ang iyong KTP at kumpletuhin ang face recognition para makumpirma ang iyong identidad." },
      "pending": { "title": "Isinasagawa ang verification", "desc": "Pinoproseso ang iyong identity verification." },
      "ocr_failed": { "title": "Nabigo ang KTP verification", "summary": "Hindi ma-verify ang iyong KTP.", "desc": "Paki-upload muli ng malinaw at wastong larawan ng KTP.", "bannerDesc": "Hindi pumasa sa verification ang iyong KTP photo. Mag-upload ng mas malinaw na KTP photo.", "nextTitle": "Mga tip sa KTP photo", "nextDesc": "• Gamitin ang front side ng KTP.\n• Tiyaking nakikita ang text, portrait, at apat na sulok.\n• Iwasan ang glare, anino, at blur." },
      "face_failed": { "title": "Nabigo ang face verification", "summary": "Pasado na ang iyong KTP. Hindi naging matagumpay ang face verification.", "desc": "Pakisubukan muli ang face verification at tiyaking malinaw na nakikita ang iyong mukha.", "bannerDesc": "Pasado na ang iyong KTP. Subukan muli ang face verification upang magpatuloy.", "nextTitle": "Mga tip sa face verification", "nextDesc": "• Tiyaking malinaw na nakikita ang iyong mukha.\n• Gumamit ng magandang ilaw at iwasan ang mask o sunglasses.\n• Sundin ang mga prompt sa face verification page." },
      "error": { "title": "Hindi ma-load", "desc": "Hindi ma-load ang iyong verification status. Pakisubukan muli." }
    },
    "docs": {
      "familyCardDesc": "I-upload ang iyong Family Card",
      "socialMediaDesc": "I-upload ang screenshot ng iyong aktibong social media account (hal. Instagram, Facebook)",
      "bankStatementDesc": "I-upload ang bank statement para sa nakaraang 3 buwan",
      "payslipDesc": "I-upload ang iyong pinakabagong payslip o salary certificate",
      "driverLicenseFrontDesc": "I-upload ang iyong valid na lisensya sa pagmamaneho",
      "driverLicenseBackDesc": "I-upload ang iyong valid na lisensya sa pagmamaneho",
      "bpjsTkDesc": "I-upload ang inyong valid na BPJS Ketenagakerjaan",
      "familyCardVerifiedDesc": "Na-verify na ang iyong Family Card.",
      "socialMediaVerifiedDesc": "Na-verify na ang screenshot ng iyong social media account.",
      "bankStatementVerifiedDesc": "Na-verify na ang iyong bank statement para sa nakaraang 3 buwan.",
      "payslipVerifiedDesc": "Na-verify na ang iyong payslip o katibayan ng sahod.",
      "driverLicenseVerifiedDesc": "Na-verify na ang iyong lisensya sa pagmamaneho.",
      "bpjsTkVerifiedDesc": "Na-verify na ang inyong BPJS Ketenagakerjaan card."
    }
  },
  "ktpCamera": {
    "title": "KTP document",
    "subtitle": "I-scan ang iyong KTP",
    "pageDesc": "Kumuha ng malinaw na larawan o piliin ang harap ng iyong KTP mula sa gallery. Maaari mo itong suriin bago ipadala.",
    "frontTitle": "Harap ng KTP",
    "frontOnly": "Harap lamang ang kailangan",
    "readyShort": "Ready",
    "notReady": "Not ready",
    "checkAgain": "Needs review",
    "emptyPreview": "Wala pang KTP photo",
    "gallery": "Gallery",
    "takePhoto": "Take photo",
    "retakePhoto": "Kumuha ulit",
    "beforeSend": "Bago ipadala",
    "checkTextPortrait": "Malinaw ang teksto at portrait",
    "checkUseKtpFront": "Gamitin ang front side ng iyong KTP, hindi ibang larawan",
    "checkNoGlare": "Walang glare o reflection",
    "checkCorners": "Nakikita ang lahat ng apat na sulok",
    "checkCornersVisible": "Ilagay ang KTP upang makita ang lahat ng apat na sulok",
    "securityNote": "Ang iyong KTP photo ay encrypted habang ina-upload at ginagamit lamang para sa identity verification.",
    "sendVerification": "Send for verification",
    "frontHint": "Kumuha ng malinaw na larawan ng portrait side ng iyong Indonesian ID card.",
    "cameraPermission": "Lalabas ang preview ng camera kapag ibinigay ang pahintulot",
    "openCamera": "Buksan ang camera",
    "choosePhoto": "Pumili ng larawan",
    "guideTip": "Ilagay ang buong card sa loob ng frame. Iwasan ang glare, anino at mga daliri.",
    "align": "I-align ang card sa loob ng frame",
    "keepInsideFrame": "Panatilihin ang apat na sulok sa loob ng frame",
    "moveCloser": "Ilapit ang KTP sa kamera",
    "analyzing": "Sinusuri ang ilaw at linaw...",
    "ready": "Maayos - i-tap para kumuha ng larawan",
    "capture": "Kumuha ng larawan",
    "retake": "Kumuha ulit",
    "confirm": "I-upload at magpatuloy",
    "qualityPassed": "Handa na ang larawan",
    "qualityWarning": "Mabilis na tingnan ang larawan",
    "qualityPassedDesc": "Na-crop at na-compress ang larawan para sa OCR upload.",
    "notKtpPhoto": "Hindi namin makita ang kumpletong KTP sa larawang ito. I-upload ang front side ng iyong KTP.",
    "cornersNotVisible": "Nasa labas ng frame ang KTP. Siguraduhing nakikita ang lahat ng apat na sulok.",
    "ktpTooSmall": "Masyadong maliit ang KTP sa larawan. Ilapit ito sa camera at subukan muli.",
    "tooDark": "Masyadong madilim ang larawan. Kumuha ng larawan sa mas maliwanag na lugar.",
    "tooBright": "Masyadong maliwanag ang larawan. Iwasan ang reflection sa card.",
    "lowQuality": "Hindi pa sapat ang linaw ng larawan. Siguraduhing malinaw ang teksto, portrait, at apat na sulok ng KTP.",
    "autoCrop": "Edge crop",
    "guideCrop": "Guide crop",
    "previewAlt": "Processed KTP preview",
    "cameraUnsupported": "Hindi suportado ang camera sa browser na ito.",
    "cameraFailed": "Hindi mabuksan ang camera. Tingnan ang browser permission o pumili ng larawan.",
    "processFailed": "Hindi ma-process ang larawang ito. Pumili ng ibang larawan.",
    "invalidDocument": "Hindi namin ma-verify ang KTP photo na ito. Kumuha ulit o mag-upload ng mas malinaw na front side ng iyong KTP.",
    "documentServiceUnavailable": "Pansamantalang hindi available ang KTP verification. Subukan ulit mamaya.",
    "sessionExpired": "Nag-expire na ang KTP verification session na ito. Simulan muli ang verification.",
    "uploadNetworkFailed": "Hindi ma-upload ang KTP photo. Tingnan ang network at subukan muli."
  },
  "kycV2": {
    "enterKtp": "Papasok sa KTP verification...",
    "enterFace": "Papasok sa face verification..."
  },
  "kycPop": {
    "faceVerify": "Verification ng Mukha",
    "faceDesc": "Para masiguro ang seguridad ng transaksyon, kailangan naming i-verify ang iyong identidad sa pamamagitan ng facial recognition",
    "faceBullet1": "Aabutin ng humigit-kumulang 30 segundo",
    "faceBullet2": "Isang beses lang na verification",
    "faceBullet3": "Ang iyong data ay ligtas na protektado",
    "faceNote": "PAALALA:",
    "faceEnvTip": "Sigurado ka na nasa maginhawang lugar ka at malinaw na nakikita ang iyong mukha",
    "facePrivacy": "Sumasang-ayon ako sa pagkuha at pagproseso ng aking biometric data para sa mga layunin ng pag-verify ng identidad alinsunod sa ",
    "facePrivacyLink": "\"Privacy Policy\"",
    "faceBtn": "Simulan ang Verification",
    "identityVerify": "Verification ng Identidad",
    "identityDesc": "Para masiguro ang seguridad ng transaksyon, kailangan naming i-verify ang iyong identidad",
    "identityBullet1": "Aabutin ng humigit-kumulang 30 segundo",
    "identityBullet2": "Isang beses lang na verification",
    "identityBullet3": "Ang iyong data ay ligtas na protektado",
    "identityStep1": "1: Kumuha ng litrato ng iyong ID",
    "identityStep2": "2: Kumpletuhin ang verification ng mukha",
    "identityNote": "PAALALA:",
    "identityEnvTip": "Gamitin ang feature na ito sa maginhawang lugar",
    "identityPrivacy": "Sumasang-ayon ako sa pagkuha at pagproseso ng aking identidad at biometric data para sa mga layunin ng verification at tumatanggap ng ",
    "identityPrivacyLink": "\"Privacy Policy\"",
    "identityBtn": "Simulan ang Verification",
    "startVerification": "Simulan ang Verification",
    "authResultSuccess": "Verification Successful",
    "redirecting": "Nagre-redirect sa payment",
    "continueToPayment": "Magpatuloy sa Payment",
    "authResultRetryDesc": "Sigurado ka na malinaw na nakikita ang iyong mukha at sapat ang ilaw",
    "authResultFailTitle": "Hindi successful ang verification ng muhata beses. Subukan muli mamaya",
    "authResultOcrFailDesc1": "Ang impormasyon ng ID ay hindi sumasadya. Manggamit ka ng sariling valid na ID card.",
    "authResultFailDesc1": "Na-cancel na ang iyong kasalukuyang order.",
    "authResultFailDesc2": "Makakagawa ka ng bagong order pagkatapos.",
    "authResultBack": "Bumalik",
    "paymentTitle": "Pagbabayad",
    "paymentDesc": "I-scan ang QR code gamit ang iyong e-wallet",
    "paymentExpiration": "Ang QR code ay expired sa loob ng",
    "paymentStep1": "Buksan ang iyong e-wallet (e.g. OVO / GCash)",
    "paymentStep2": "Pindutin ang \"Scan\"",
    "paymentStep3": "I-scan ang QR code para makumpleto ang pagbabayad",
    "saveQR": "I-save ang QR",
    "paymentExpired": "Expired na ang pagbabayad, mangyaring subukan muli"
  },
}
export default ph;
